// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_3tmL9sj","rotate":"TU1uscG","small":"_3K6nApD","medium":"_3Vr8zk3","large":"_1_Zl65u","x-large":"_3FK6YrF","default":"_1g53O20","centre":"_1rp6Amp"};